






import React, { useState, useEffect } from "react";
import { BiDirections } from "react-icons/bi";
import { Link } from "react-router-dom";

const SearchByCategory = () => {
  const [industryJobs, setIndustryJobs] = useState({});

useEffect(() => {
  const fetchJobs = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}job/jobs?page=1&limit=100`);
      const result = await response.json();
      console.log(result);

      const jobs = result.data; // ← unwrap the actual array

      if (Array.isArray(jobs)) {
        const groupedByIndustry = jobs.reduce((acc, job) => {
          const industry = (job.industry || "Others").trim().toLowerCase();
          acc[industry] = acc[industry] || [];
          acc[industry].push(job);
          return acc;
        }, {});
        setIndustryJobs(groupedByIndustry);
        console.log(groupedByIndustry);
      }
    } catch (error) {
      console.error("Error fetching jobs:", error);
    }
  };
  fetchJobs();
}, []);

  return (
    <div>
      <div className="flex flex-row items-center justify-center pl-4 md:pl-20">
        <h1 className="text-4xl font-extrabold text-center uppercase mb-2 text-gray-900">
          Popular Job Categories
        </h1>
        <div className="p-2 w-fit rounded-full text-orange-500 text-xl ml-2">
          <BiDirections />
        </div>
      </div>

      <p className="text-center text-gray-700 mb-10 max-w-2xl mx-auto">
        By utilizing our paid job listing, your jobs are displayed to more
        applicants. Joblink.ng is the most visited job platform in Nigeria,
        ensuring your job postings gain the maximum exposure.
      </p>

      <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6 max-w-6xl mx-auto px-4">
        {Object.keys(industryJobs).map((industry) => (
          <li key={industry}>
            <Link
              to={`/jobs/category/${encodeURIComponent(industry)}`}
              className="bg-white border-2 border-gray-200 rounded-xl p-6 text-center 
                         hover:shadow-lg hover:border-purple-400 transition-all duration-300 
                         flex flex-col justify-between h-full block"
            >
              <div>
                <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full mx-auto mb-4 flex items-center justify-center">
                  <BiDirections className="w-7 h-7 text-white" />
                </div>

                <h3 className="text-sm font-semibold text-gray-800 leading-tight capitalize">
                  {industry}
                </h3>

                <p className="text-sm text-gray-500 mt-2">
                  {industryJobs[industry]?.length || 0} job
                  {industryJobs[industry]?.length !== 1 ? "s" : ""}
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SearchByCategory;